<template>
  <section class="wrapper-content w-100">
    <h1>Administrar el menú "Configuración"</h1>

    <draggable
      v-if="!isLoading"
      class="list-group my-3"
      tag="ul"
      v-model="items"
      animation="200"
      @start="drag = true"
      @end="drag = false"
      handle=".handle"
    >
      <b-input class="my-4 w-50" placeholder="Filtrar punto de menú" v-model="searchText"></b-input>
      <b-card v-for="(item, index) of filteredItems" :key="index" class="handle">
        <h3>{{ item.name }}</h3>
        <pre>{{ item.path }}</pre>
        <b-checkbox v-model="item.superuserOnly" switch>Solo visible para el superusuario</b-checkbox>
      </b-card>
    </draggable>
    <b-row>
      <LmButton
        :value="$t('cancel')"
        class="col-auto"
        buttonClass="btn-secondary"
        @click="$router.go(-1)"
      />
      <LmButton
        :value="$t('save')"
        class="col-auto"
        buttonClass="btn-primary"
        @click="onSubmit"
      />
    </b-row>
  </section>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import draggable from 'vuedraggable'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmButton,
    draggable
  },
  data () {
    return {
      isLoading: false,
      searchText: '',
      items: []
    }
  },
  computed: {
    filteredItems () {
      return this.items.filter(el => el.name.toLowerCase().search(this.searchText.toLowerCase()) !== -1)
    }
  },
  methods: {
    async onSubmit () {
      try {
        await commonsApi.axiosPutWrapper('/frontendmenus/admin-menu', {
          items: this.items
        })
        this.lmToastSuccessMessage('Cambios guardados correctamente.', 'Se guardó exitosamente')
      } catch (error) {
        console.log(error)
      }
    }
  },
  async mounted () {
    try {
      this.isLoading = true
      const menuResponse = await commonsApi.axiosGetWrapper('/frontendmenus/admin-menu')
      this.items = menuResponse.data.childs
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
